// extracted by mini-css-extract-plugin
export default {"root":"Home_root__7NLch","stats":"Home_stats__x-fOT"};